import { render, staticRenderFns } from "./header-image.vue?vue&type=template&id=ca2e0f60&scoped=true"
import script from "./header-image.vue?vue&type=script&lang=js"
export * from "./header-image.vue?vue&type=script&lang=js"
import style0 from "./header-image.vue?vue&type=style&index=0&id=ca2e0f60&prod&lang=scss&scoped=true"
import style1 from "./header-image.vue?vue&type=style&index=1&id=ca2e0f60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2e0f60",
  null
  
)

export default component.exports